/**
 * Creates a object for every .components-form-Daterange DOM element.
 */
common.View.create('crud::form.inputs.Daterange', {

    options: {
        showDropdowns: true,
        locale: require('./../daterangepicker').locale,
        autoUpdateInput: false,
    },

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initOptions();
        this.initDatepicker();
    },

    initOptions()
    {
        // Set time on daterange
        if (this.element.find('input').data('time') || this.element.find('input').data('timeseconds')) {
            this.options.timePicker = true;
            this.options.timePicker24Hour = true;
            this.options.locale.format = 'DD-MM-YYYY h:mm';
            this.options.locale.hiddenFormat = 'YYYY-MM-DD h:mm:ss';
        }

        // Set seconds on daterange
        if (this.element.find('input').data('seconds') || this.element.find('input').data('timeseconds')) {
            this.options.timePickerSeconds = true;
            this.options.locale.format = 'DD-MM-YYYY h:mm:ss';
            this.options.locale.hiddenFormat = 'YYYY-MM-DD h:mm:ss';
        }

        // Check if user wants to show date ranges
        if( this.element.find('input').data('showRange') ) {

            this.options.alwaysShowCalendars = true;
            this.options.ranges = this.element.data('ranges') || {
                'Vandaag': [moment(), moment()],
                'Gisteren': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Laatste 7 dagen': [moment().subtract(6, 'days'), moment()],
                'Laatste 30 dagen': [moment().subtract(29, 'days'), moment()],
                'Deze maand': [moment().startOf('month'), moment().endOf('month')],
                'Laatste maand': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Dit jaar': [moment().startOf('year'), moment().endOf('year')],
                'Laatste jaar': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
            };
        }
    },

    initDatepicker()
    {
        $('input[name=""]', this.element)
            .daterangepicker(this.options)
            .on('input apply.daterangepicker', this.onChange.bind(this))
            .on('input cancel.daterangepicker', (ev, picker) => {
                //do something, like clearing an input
                this.element.find('input[name=""]').val('');

                if(this.element.find('input').data('refresh')) {
                    // Refresh the page with new parameters
                    const params = new URLSearchParams(window.location.search);
                        params.set('daterange', '');
                        window.location.search = params.toString();
                }
            })
    },

    onChange(ev, picker)
    {
        this.updateVisibleInput(ev, picker);
        this.updateHiddenInputs(ev, picker);
        
        if( this.element.find('input').data('refresh') ) {
            // Refresh the page with new parameters
            const params = new URLSearchParams(window.location.search);
                params.set('daterange', picker.startDate.format(this.options.locale.format) + ' - ' + picker.endDate.format(this.options.locale.format));
                window.location.search = params.toString();
        }
    },

    updateVisibleInput(ev, picker)
    {
        $('input[name=""]', this.element)
            .val(picker ? picker.startDate.format(this.options.locale.format)
                + ' - '
                + picker.endDate.format(this.options.locale.format)
                : '');
    },

    updateHiddenInputs(ev, picker)
    {
        // Loop hidden inputs.
        _.each($('input:not([name=""])', this.element), (input, index) =>
        {
            // Set value?
            if (picker)
                $(input).val(picker[index == 0 ? 'startDate' : 'endDate'].format(this.options.locale.hiddenFormat));

            // Clear value?
            else
                $(input).val('');
        });
    }

});
